module.exports = __webpack_public_path__ + "static/sre-logoo-01e8e5794ea6b532cc2c0ed37c644320.png";